// Matriz especialidad × tipo de falla (hoja "Matriz sugerida").
//
// SUGERENCIA, NUNCA BLOQUEO (spec §8 / invariante 7, y en palabras del
// propio xlsx: "un inspector que no puede registrar lo que está viendo,
// delante del cliente, mata la demo en un minuto"). Uso permitido:
// ORDENAR candidatas del clasificador y sugerencias del dashboard
// (combinación esperada primero). Uso prohibido: filtrar, deshabilitar
// o rechazar — ningún superRefine, guard de ruta ni validador la lee
// en posición de rechazo (fitness: taxonomy-matrix-never-blocks).
// Una combinación NO marcada que la IA propone con alta confianza y el
// humano confirma es la señal de ampliación (revisión trimestral) —
// evento `taxonomy.matrix_gap` en la captura de correcciones (ola 3).
//
// Correcciones v1→v2 ya incorporadas: TAB y ELE admiten TF-04 (el
// "tablero mojado" era incodificable), GAS puede codificar una fuga, y
// TF-18 (aseo) aplica a todas.
export const MATRIZ_ESPERADA = Object.freeze({
    EST: ["TF-01", "TF-03", "TF-04", "TF-06", "TF-07", "TF-08", "TF-10", "TF-16", "TF-17", "TF-18"],
    TAB: [
        "TF-01",
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    REV: ["TF-01", "TF-03", "TF-04", "TF-05", "TF-10", "TF-11", "TF-16", "TF-17", "TF-18"],
    PAV: [
        "TF-01",
        "TF-02",
        "TF-03",
        "TF-04",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    PVE: [
        "TF-02",
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-06",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-13",
        "TF-14",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    MUE: [
        "TF-02",
        "TF-03",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-13",
        "TF-14",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    SAN: [
        "TF-02",
        "TF-03",
        "TF-04",
        "TF-06",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-12",
        "TF-13",
        "TF-14",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    INS: ["TF-03", "TF-04", "TF-06", "TF-10", "TF-11", "TF-12", "TF-13", "TF-14", "TF-15", "TF-18"],
    ELE: ["TF-03", "TF-04", "TF-06", "TF-10", "TF-13", "TF-14", "TF-15", "TF-16", "TF-17", "TF-18"],
    GAS: ["TF-03", "TF-04", "TF-06", "TF-10", "TF-11", "TF-12", "TF-13", "TF-14", "TF-15", "TF-18"],
    CLI: [
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-06",
        "TF-10",
        "TF-11",
        "TF-12",
        "TF-13",
        "TF-14",
        "TF-15",
        "TF-18",
    ],
    IMP: [
        "TF-01",
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-06",
        "TF-07",
        "TF-10",
        "TF-11",
        "TF-12",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    FAC: [
        "TF-01",
        "TF-02",
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-06",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
    OTR: [
        "TF-01",
        "TF-02",
        "TF-03",
        "TF-04",
        "TF-05",
        "TF-06",
        "TF-07",
        "TF-08",
        "TF-09",
        "TF-10",
        "TF-11",
        "TF-12",
        "TF-13",
        "TF-14",
        "TF-15",
        "TF-16",
        "TF-17",
        "TF-18",
    ],
});
//# sourceMappingURL=matriz.js.map